<template>
  <div class="app-container">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="未处理" name="first"></el-tab-pane>
      <el-tab-pane label="已处理" name="second"></el-tab-pane>
    </el-tabs>
    <list ref="list">
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="160" v-if="$permission.canWrite()" >
          <template slot-scope="{ row,$index }">
            <el-button type="text" v-if="!row.PieceSalaryStatus" @click="onEdit(row,$index)" :disabled="row.isEditBtn">{{ row.isEdit ? '保存' : '编辑' }}</el-button>
            <el-button type="text" v-if="!row.PieceSalaryStatus" @click="onPrice(row,$index)" :disabled="!row.isEdit">取价</el-button>
            <el-button type="text" v-if="row.PieceSalaryStatus" @click="onOffDispose(row,$index)" >取消处理</el-button>
            <!-- <el-button type="text" v-if="$permission.canWrite()" @click="onEdit(row,$index)" >取排班</el-button> -->
          </template>
        </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/production/piecerate/orderwage/list";
// import editDialog from '@/components/production/clothmanagement/cloth/editDialog'

export default {
  name: "orderwage",
  mixins: [curdMixins],
  data() {
    return {
      api: require("@/api/pr/prPieceSalary").default,
      prProcessWagesApi: require("@/api/pr/prProcessWages").default,
      activeName: "first",
    };
  },
  components: {
    list,
    // editDialog
  },
  methods: {
    delRows() {},
    handleClick() {
      const Status = this.activeName == "first" ? 0 : 1;
      this.$refs.list.getData({Status});
    },
    onOffDispose(row){
      this.$confirm("是否取消处理？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const ids = [row.PieceSalaryId]
          this.api.updateStatus(ids).then(res => {
            if (res.Code == 0) {
              this.$message.success("保存成功");
              this.$refs.list.reload();
            } else {
              this.$message.warning(res.Msg);
              this.$refs.list.reload();
            }
          })
        })
        .catch(() => {});
    },
    onPrice(row,index) {
      const o = {
        ProcessId: row.ProcessId,
        ProductId: row.ProductId,
      }
      this.prProcessWagesApi.getProcessWages(o).then(res => {
        if (res.Code == 0) {
          this.$set(row, "PiecePrice", res.Data);
          this.$set(row, "PieceAmount", ((res.Data * row.Quantity) * 100) /100).toFixed(2);
          
          row.ListData.forEach((item) => {
            this.$set(item, "PiecePrice", res.Data);
            this.$set(item, "PieceAmount", ((res.Data * item.PieceQuantity) * 100) /100).toFixed(2);
            this.$set(item, "Ratio", ((item.PieceQuantity / row.Quantity) * 100) /100).toFixed(2);
          });
        } else {
          this.$message.warning(res.Msg);
        }
      })
    },
    onEdit(row,index) {
      if (row.isEdit) {
        console.log('保存');
        this.$set(row, "isEdit", false);
        const params = {
          PieceSalaryId:row.PieceSalaryId ?? 0,
          PieceUnitId:row.UnitId,
          PieceQuantity:row.Quantity,
          PiecePrice:row.PiecePrice,
          PieceAmount:row.PieceAmount,
          Remark:row.PieceSalaryRemark,
          SourceDocId:row.DocId,
          SourceDtsId:row.DocProductId,
          ListData:row.ListData.filter((i) => i.EmpId)
        }
        this.api.save(params).then(res => {
          if (res.Code == 0) {
            this.$message.success("保存成功");
            this.$refs.list.reload();
          } else {
            this.$message.warning(res.Msg);
            this.$refs.list.reload();
          }
        })
      } else {
        console.log('编辑');
        this.$refs.list.$refs.list.data.forEach((item) => {
          this.$set(item, "isEditBtn", true);
        });
        this.$set(row, "isEdit", true);
        this.$set(row, "isEditBtn", false);
      }
      this.$refs.list.setIsEdit()
    },
  },
};
</script>
